/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus-w': {
    width: 16,
    height: 16,
    viewBox: '0 0 8.15 8.54',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M4.85 8.54H3.3V5H0V3.47h3.3V0h1.55v3.47h3.3V5h-3.3z" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/plus-w.js